import type { PropsWithChildren } from 'react';
import { FaPlus } from 'react-icons/fa';
import { BREAKPOINTS } from '@presentation/styles';
import { useMediaQuery } from 'react-responsive';
import * as Styled from './styled';
import type { InputRadioProps } from './types';

export * from './types';

export const InputRadio = <TValue,>(props: PropsWithChildren<InputRadioProps<TValue>>) => {
  const {
    name,
    options,
    onSelect,
    multiple = false,
    disabled = false,
    grow = false,
    showAdd = false,
    hasError = false,
    onAddClick,
    value,
    separated,
    separatedOnDesktop,
    autoHeight,
    autoWidth,
    hideSelectedIcon,
    langSelector = false,
    variant,
    preventDefault = false,
    ...rest
  } = props;

  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.phone}px)` });

  const Container =
    (separatedOnDesktop && !isMobile) || separated ? Styled.SeparatedContainer : Styled.Container;

  const Wrapper =
    (separatedOnDesktop && !isMobile) || separated ? Styled.SeparatedWrapper : Styled.Wrapper;

  return (
    <Container {...rest}>
      {options.map((option, index) => (
        <Wrapper
          data-name={name}
          grow={grow}
          key={`${option.value}-${index}`}
          hasError={hasError}
          onClick={(e) => {
            if (!disabled) {
              onSelect?.(option);
            }
            if (preventDefault) {
              e.preventDefault();
            }
          }}
          active={
            multiple
              ? ((value as TValue[]) ?? []).includes(option.value)
              : // eslint-disable-next-line eqeqeq
                (value as TValue) == option.value
          }
          disabled={disabled}
          hideSelectedIcon={hideSelectedIcon}
          autoHeight={autoHeight}
          autoWidth={autoWidth}
          langSelector={langSelector}
          variant={variant}
        >
          {!!option.iconLeft && (
            <Styled.IconLeftWrapper hasLabel={!!option.label}>
              {option.iconLeft}
            </Styled.IconLeftWrapper>
          )}
          {option.label}
          {!!option.iconRight && (
            <Styled.IconRightWrapper hasLabel={!!option.label}>
              {option.iconRight}
            </Styled.IconRightWrapper>
          )}
        </Wrapper>
      ))}
      {!!showAdd && (
        <Wrapper
          onClick={onAddClick}
          active={false}
          grow={false}
          disabled={disabled}
          hasError={hasError}
          variant={variant}
        >
          <FaPlus />
        </Wrapper>
      )}
    </Container>
  );
};
